import React from 'react'
import Helmet from 'react-helmet'
import { withPrefix } from 'gatsby-link'

import Header from '../components/header'
import Footer from '../components/footer'

import './index.scss'

var Scroll = require('react-scroll');
var Element = Scroll.Element;
var scroller = Scroll.scroller;

function scroll() {
  scroller.scrollTo('top')
  scroller.scrollTo(window.location.pathname.replace('/',''), {
    duration: 1500,
    delay: 50,
    smooth: true,
    offset: -80,
  })
}

class TemplateWrapper extends React.Component {
  componentDidMount() {
    scroll()
  }

  componentDidUpdate() {
    scroll()
  }

  render() {
    const title = 'Jared Silver :: EdTech Software Developer & Designer'
    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta property="og:image" content={`https://jaredasilver.com/jaredsilver.jpg`} />
        </Helmet>
        <Header />
        <main>
          {this.props.children()}
        </main>
        <Footer data={this.props.data.allContactYaml.edges} />
      </div>
    )
  }
}

export default TemplateWrapper

export const query = graphql`
query ContactQuery {
  allContactYaml {
    edges {
      node {
        name
        link
        icon
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/index.js